module.exports = __webpack_public_path__ + "static/media/background-map.5ba09eda.jpg";